import { classNames } from '../util';

export default function LoadingSpinner({ height = 'screen' }: { height?: 'screen' | 'auto' }) {
  return (
    <div className={classNames('flex items-center justify-center', `h-${height}`)}>
      <div className="h-32 w-32 animate-spin rounded-full border-t-2 border-b-2 border-licorice-noir"></div>
    </div>
  );
}
